/*!
 * Bootstrap
 * ---
 * Here execute/import all the needed information before mounting the main instance
 * of Vue. After all instructions are done the promise resolves an creates the
 * Vue instance.
 */
import './styles/app.scss'
import Http from './Http'
import routes from './routes'
import * as helpers from './helpers'
import EntityModule from './store/EntityModule'
import {
  AppField,
  AppCreateField,
  AppEntityAddField,
  AppRuleController,
  AppEntityForm,
  AppEntityList,
  AppOldEntityList,
  AppOrderLinesTab,
  AppEntityModal,
  AppLoader,
  AppFiles,
  AppFileControl,
  GCommentsTimeLine,
  GTagSymbol,
  AppEntityAutocomplete,
  GComment,
  GActionRoles,
  DateField,
  TimeField,
  AppDateTimePicker,
  GBtn,
  GTextField,
  GNavigationDrawer,
  GDataTable,
  GSelect,
  GChip,
  GTimePicker,
  AppEntityController,
  AppEntityDisplay,
  EntityStepper,
  AppPartyContacts,
  AppDateRangePicker,
  AppEntityPivot,
  AppSimpleEntitySearch,
  AppChangeLogTimeline,
  ArrayField,
} from '@@/components'
import headers from '../Graph/components/ui/Header/Header.js';
import { AppEntityControllerMultiple } from './components/entities'

// Get Schema is trying to fetch the schema from the endpoint, which will return a 401 code
// if the user is null, causing this function to fail and clear the local storage and schema.
const getSchema = async (axios) =>  {
  try{
    const schemaZipFile = await helpers.ZipFile(helpers.SCHEMA_URL, axios);
    const schemaJsonString = await helpers.getFileFromZip(schemaZipFile, "schema.min.json");
    window.$Schema = JSON.parse(schemaJsonString);
  }catch(e)
  {
    console.log(e);
    window.$Schema = [];
    window.localStorage.clear();
  }
}

export default async (axios, options = { }) => {
  // First wee load the env variable that holds constants and very important data
  // for the application to boot.
  // TODO : Trow an exception iof the file its corrupted
  window.ENV = await helpers.tryPromise(axios.get(process.env.VUE_APP_PUBLIC_PATH + 'projectConfig.json', { baseURL: '/' }))
  // Then we configured Http/axios with values from the ENV variable.
  window.$Http = Http(axios)
  // Fetch Bearer from local to maintain the user session.
  //const user = JSON.parse(window.localStorage.getItem('user') || '{}')
  const userData = helpers.getStorageUser();
  axios.defaults.headers.common.Authorization = `Bearer ${_.get(userData, 'token')}`;
  // Then we are able to make a request to ask for the DB/Backend/Graph schema.
  // This call its also responsable for retriving the permissions and the user information.
  if(options.schema) {
    await getSchema(axios);
  }

  return  {
    install (Vue, { store, router } = {}) {
      router.addRoutes(routes)
      store.registerModule('schema', EntityModule)
      Vue.component('app-field', AppField)
      Vue.component('app-create-field', AppCreateField)
      Vue.component('app-rule-controller', AppRuleController)
      Vue.component('app-entity-form', AppEntityForm)
      Vue.component('app-entity-add-field', AppEntityAddField)
      Vue.component('app-entity-list', AppEntityList)
      Vue.component('app-old-entity-list', AppOldEntityList)
      Vue.component('app-entity-modal', AppEntityModal)
      Vue.component('app-loader', AppLoader)
      Vue.component('app-files', AppFiles)
      Vue.component('app-file-control', AppFileControl)
      Vue.component('app-datetime-picker', AppDateTimePicker)
      Vue.component('app-orderlines-tab', AppOrderLinesTab)
      Vue.component('g-comments-timeline', GCommentsTimeLine)
      Vue.component('g-tag-symbol', GTagSymbol)
      Vue.component('app-entity-autocomplete', AppEntityAutocomplete)
      Vue.component('g-comment', GComment)
      Vue.component('g-action-roles', GActionRoles)
      Vue.component('g-btn', GBtn)
      Vue.component('g-text-field', GTextField)
      Vue.component('g-navigation-drawer', GNavigationDrawer)
      Vue.component('g-data-table', GDataTable)
      Vue.component('g-select', GSelect)
      Vue.component('g-chip', GChip)
      Vue.component('g-time-picker', GTimePicker)
      Vue.component('app-entity-controller', AppEntityController)
      Vue.component('app-entity-display', AppEntityDisplay)
      Vue.component('app-entity-stepper', EntityStepper)
      Vue.component('app-entity-pivot', AppEntityPivot)
      Vue.component('app-daterange-picker', AppDateRangePicker)
      Vue.component('app-party-contacts', AppPartyContacts)
      Vue.component('app-entity-controller-multiple', AppEntityControllerMultiple)
      Vue.component('app-simple-entity-search', AppSimpleEntitySearch)
      Vue.component('app-change-log-timeline', AppChangeLogTimeline)
      Vue.component('app-array-field', ArrayField)
      Object.keys(headers).forEach( hkey => {
        Vue.component(hkey, headers[hkey])
      })
      store.commit('SET_SCHEMA', window.$Schema)
      // Add a response interceptor
      axios.interceptors.response.use(async function (response) {
        // console.log(response.headers)
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        // if (response.config.method === 'post' && ENV.AFFECT_SCHEMA[response.data._Entity]) {
        //   await helpers.$updateSchema(store, axios)
        // }
        return response;
      }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        //If Error is 401 (UnauthorizedResult - show when user is not logged in)
        if(error.toString().includes("401")) {
          window.location.reload();
          return;
        }

        let { response: { data: { errors } } } = error
        console.log('REQUEST ERRORS', errors)
        if (errors) {
          store.commit('SET_ERRORS', errors)
          store.commit('SET_ERROR_MODAL', true)
        }
        return Promise.reject(error);
      });

      Vue.prototype.$window = window
      for (let key in helpers) {
        Vue.prototype[`$${key}`] = function (...arg) {
          // FetchEntity needs axios to make a request, but we don't want to import
          // all the axios library when building the library.
          return helpers[key].apply(this, arg)
        }
      }
    }
  }
}
